module.exports = __webpack_public_path__ + "static/media/mitsubishi-pajero.73f04c42.webp";